import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductListItemDto } from './ProductListItemDto'
/**
* Class ShowcasePageBlockProductsDto
*  Опубликованный блок «Товары». Источник читается по наличию Web.Api.Showcases.Controllers.PageBlocks.Models.ShowcasePageBlockProductsDto.ProductCollectionId.
*/
export class ShowcasePageBlockProductsDto extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Products' })
  readonly type: string = 'Products'


/**
  * key
  * Ключ слота; уникален в рамках канала среди неудалённых.<br>Задаётся оператором; шаблон витрины запрашивает блок по этому ключу.<br>
  */
  @ActiveField('')
  key: string = ''


/**
  * sectionTitle
  * Заголовок секции. Пустая строка — витрина не рисует заголовок.
  */
  @ActiveField()
  sectionTitle?: string


  /**
  * productCollectionId
  * Идентификатор подборки. Отсутствует у выбранных товаров.  */
  @ActiveField()
  productCollectionId?: null | number


/**
  * @property items
  * Видимые карточки товаров.  */
  @ActiveField({
    factory: [ProductListItemDto, () => undefined]
  })
  items?: Array<ProductListItemDto>
}
